<template>
  <div class="row bloc-information mt20 mb20">
    <div class="col-lg-3" v-if="!seller && !owner && !seller.firstName && !owner.firstName"></div>
    <div class="col-lg-6">
      <div class="ibox float-e-margins">
        <div class="ibox-content col-lg-4" style="min-height: 155px;">
          <img v-if="quotation.image" :src="quotation.image" class="img-vehicle">
          <img v-else :src="quotation.car.photo" class="img-vehicle">
        </div>
        <div class="col-lg-8 no-paddings">
          <div class="ibox-title">
            <h5 style="position:absolute; width:96%;">
              <strong>{{ this.vehicle.version.name }}</strong><br>
              <span v-if="estimationInfos && estimationInfos.sellerPrice" class="orange">{{ this.estimationInfos.sellerPrice }} €</span>
              <span v-else class="orange">{{ this.quotation.sellerPrice }} €</span>
            </h5>
          </div>
          <div class="ibox-content" style="border-top:none;">
            <i class="fa fa-road"></i> {{ this.vehicle.kilometer }} km<br>
            <i class="fa fa-money"></i> {{ this.vehicle.fuel.name }}<br>
            <i class="fa fa-flag-checkered"></i>
            <span v-if="vehicle.licensePlate"> {{ this.vehicle.licensePlate }},</span>
            {{ this.vehicle.yearMEC }},
            {{ this.vehicle.gearType.name }}<br>
          </div>
        </div>
      </div>
    </div>
    <div class="col-lg-3" v-if="seller && seller.firstName">
      <div class="ibox float-e-margins">
        <div class="ibox-title">
          <h5>Vendeur</h5>
        </div>
        <div class="ibox-content">
          <i class="fa fa-user"></i> {{ seller.firstName + ' ' + seller.lastName }}<br>
          <i class="fa fa-phone"></i> {{ seller.phone }}<br>
          <i class="fa fa-envelope"></i> {{ seller.email }}
        </div>
      </div>
    </div>
    <div class="col-lg-3" v-if="owner && owner.firstName">
      <div class="ibox float-e-margins">
        <div class="ibox-title">
          <h5>Titulaire</h5>
        </div>
        <div class="ibox-content">
          <i class="fa fa-user"></i> {{ owner.firstName + ' ' + owner.lastName }}<br>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "GeneralInfos",

    props: {
      quotation: {
        type: Object
      },
      vehicle: {
        type: Object
      },
      seller: {
        type: Object
      },
      owner: {
        type: Object
      },
      estimationInfos: {
        type: Object
      }
    }
  }
</script>

<style scoped>

</style>
